import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["loader", "image"]

  connect() {
    this.loadedCount = 0;
    this.totalImages = this.imageTargets.length;
    if (this.totalImages === 0) {
      this.hideLoader();
      return;
    }
    this.imageTargets.forEach(img => {
      if (img.complete) {
        this.incrementLoaded();
      } else {
        img.addEventListener('load', this.incrementLoaded.bind(this));
        img.addEventListener('error', this.incrementLoaded.bind(this));
      }
    });
  }

  incrementLoaded() {
    this.loadedCount++;
    if (this.loadedCount === this.totalImages) {
      this.hideLoader();
    }
  }

  hideLoader() {
    this.loaderTarget.classList.add('d-none');
  }
}
